/* eslint-disable no-console */

/**
 * Development-only console.log.
 *
 * The checkout used bare `console.log` for tracing, which had two costs in
 * production that were easy to miss:
 *
 *  1. PII leak. Sentry captures console output as breadcrumbs, so lines like
 *     "SHIPPING DATA BEING SENT" wrote the customer's name, street, phone and
 *     email into every error report attached to that session.
 *  2. Noise. Several of them sat in a render body or a hot price recalculation,
 *     so a single checkout produced hundreds of breadcrumbs and pushed the
 *     actually-relevant XHR entries out of the 100-breadcrumb ring buffer,
 *     which is what made the real failures hard to read.
 *
 * `process.env.NODE_ENV` is inlined at build time, so in a production bundle
 * this collapses to a no-op and the arguments are never evaluated for side
 * effects beyond their own construction.
 */
export const debugLog: (...args: unknown[]) => void =
  process.env.NODE_ENV === "production"
    ? () => {}
    : (...args: unknown[]) => console.log(...args);
